<template>
  <div class="comment-list">
    <template v-if="comments.length > 0">
      <div v-for="comment in comments" :key="comment.id" class="comment-item">
        <!-- 用户信息 -->
        <div class="user-info user-info-honer">
          <div class="user-info-left">
            <el-avatar
                :src="comment.avatar"
                :alt="comment.username"
                size="medium"
                class="avatar"
                icon="el-icon-user-solid"
            ></el-avatar>
            <div class="user-meta">
              <span class="username">{{ comment.username }}</span>
              <span class="comment-time">
                {{formatTime(comment.gmtCreated) }}
              </span>
            </div>
          </div>
          <i v-if="comment.userId == localUserId && false" class="el-icon-delete-solid" @click="deleteComment(comment.articleId)"> </i>
        </div>

        <!-- 评论内容 -->
        <div class="comment-content">
          <p>{{ comment.content }}</p>
          <!-- 评论中的图片 -->
          <div
            v-if="comment.images && comment.images.length"
            class="comment-images"
          >
            <el-avatar
              v-for="(img, index) in comment.images"
              :key="index"
              :src="img"
              size="medium"
              @click="showImagePreview(img)"
              class="comment-image"
              icon="el-icon-user"
            ></el-avatar>
          </div>
        </div>

        <!-- 操作栏 -->
        <div class="comment-actions" v-if="false">
          <button
            class="like-btn"
            :class="{ liked: comment.isLiked }"
            @click="toggleLike(comment)"
          >
            <span class="icon">👍</span>
            <span class="count">{{ comment.likeCount }}</span>
          </button>
          <button class="reply-btn" @click="showReplyBox(comment)">回复</button>
        </div>

        <!-- 回复框 -->
        <div v-if="activeReplyId === comment.id && false" class="reply-box">
          <textarea
            v-model="replyContent"
            placeholder="写下你的回复..."
            ref="replyTextarea"
          ></textarea>
          <div class="reply-actions">
            <button @click="cancelReply">取消</button>
            <button @click="submitReply(comment)" class="submit-btn">
              发送
            </button>
          </div>
        </div>

        <!-- 回复列表 -->
        <div
          v-if="comment.replies && comment.replies.length"
          class="reply-list"
        >
          <div
            v-for="reply in comment.replies"
            :key="reply.id"
            class="reply-item"
          >
            <div class="user-info">
              <img
                :src="reply.avatar"
                :alt="reply.username"
                class="avatar small"
              />
              <div class="user-meta">
                <span class="username">{{ reply.username }}</span>
                <span class="comment-time">{{
                  formatTime(reply.gmtCreated)
                }}</span>
              </div>
            </div>
            <div class="reply-content">
              <p>{{ reply.content }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 图片预览模态框 -->
      <div
        v-if="previewImage"
        class="image-preview-modal"
        @click="previewImage = null"
      >
        <img :src="previewImage" @click.stop />
      </div>
    </template>
    <div class="empty" v-else>
      <img :src="empty" alt="" />
      <p>暂无评论数据</p>
    </div>
  </div>
</template>

<script>
import {
  delComment,
} from '@/API/news/news';
export default {
  props: {
    comments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      empty: require('@/assets/recycling/index/empty.svg'),
      activeReplyId: null,
      replyContent: '',
      previewImage: null,
      localUserId:JSON.parse(localStorage.getItem('ordinaryUser')).userDetail
          .userId
          ? JSON.parse(localStorage.getItem('ordinaryUser')).userDetail.userId
          : '',
    };
  },
  methods: {
    deleteComment(id){
      delComment(id).then(res=>{
        if(res.code === 200){
          this.$message.success('评论删除成功！！！')
          this.$emit('deleteSuccess',true)
        }else {
          this.$message.success('评论删除失败！！！')
        }
      })
    },
    formatTime(timestamp) {
      const date = new Date(timestamp);
      const now = new Date();
      const diff = now - date;

      // 小于1分钟
      if (diff < 60000) return '刚刚';
      // 小于1小时
      if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`;
      // 小于1天
      if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`;
      // 小于1周
      if (diff < 604800000) return `${Math.floor(diff / 86400000)}天前`;

      // 超过1周显示具体日期
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },

    toggleLike(comment) {
      this.$emit('toggle-like', comment.id);
      comment.isLiked = !comment.isLiked;
      comment.likeCount += comment.isLiked ? 1 : -1;
    },
    showReplyBox(comment) {
      this.activeReplyId = comment.id;
      this.replyContent = '';
      this.$nextTick(() => {
        this.$refs.replyTextarea[0].focus();
      });
    },

    cancelReply() {
      this.activeReplyId = null;
      this.replyContent = '';
    },

    submitReply(comment) {
      if (!this.replyContent.trim()) return;

      const newReply = {
        id: Date.now(),
        user: {
          id: 1, // 当前用户ID
          name: '当前用户',
          avatar: 'https://example.com/current-user.jpg',
        },
        content: this.replyContent,
        createdAt: new Date().toISOString(),
      };

      if (!comment.replies) {
        this.$set(comment, 'replies', []);
      }

      comment.replies.push(newReply);
      this.$emit('reply', {
        commentId: comment.id,
        content: this.replyContent,
      });

      this.cancelReply();
    },

    showImagePreview(img) {
      this.previewImage = img;
    },
  },
};
</script>

<style lang="less" scoped>
.comment-list {
  max-width: 100%;
  padding: 40px 20px 40px 20px;
  background: #f9f9f9;
}

.comment-item {
  padding: 15px 0;
  border-bottom: 1px solid #f0f0f0;
}

.user-info {
  display: flex;
  align-items: center;
  margin-bottom: 8px;

}
.user-info-honer{
  display: flex;
  justify-content: space-between;
  .user-info-left {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .el-icon-delete-solid{
    font-size: 16px;
    color: #333333;
    cursor: pointer;
  }
  .el-icon-delete-solid:hover {
    color: #ef1111;
  }
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}

.avatar.small {
  width: 30px;
  height: 30px;
}

.user-meta {
  display: flex;
  flex-direction: column;
}

.username {
  font-weight: bold;
  font-size: 14px;
}

.comment-time {
  font-size: 12px;
  color: #999;
}

.comment-content {
  margin-left: 50px;
  margin-bottom: 10px;
}

.comment-content p {
  margin: 0;
  line-height: 1.5;
  font-size: 14px;
}

.comment-images {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  gap: 8px;
}

.comment-image {
  max-width: 150px;
  max-height: 150px;
  border-radius: 4px;
  cursor: pointer;
  object-fit: cover;
}

.comment-actions {
  margin-left: 50px;
  display: flex;
  align-items: center;
}

.like-btn,
.reply-btn {
  background: none;
  border: none;
  padding: 5px 10px;
  margin-right: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #666;
}

.like-btn.liked {
  color: #1890ff;
}

.like-btn .icon {
  margin-right: 5px;
}

.reply-box {
  margin-left: 50px;
  margin-top: 10px;
}

.reply-box textarea {
  width: 100%;
  min-height: 60px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
}

.reply-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.reply-actions button {
  padding: 5px 15px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.reply-actions .submit-btn {
  background-color: #1890ff;
  color: white;
}

.reply-list {
  margin-left: 50px;
  margin-top: 15px;
  padding-left: 15px;
  border-left: 2px solid #eee;
}

.reply-item {
  padding: 10px 0;
}

.reply-content {
  margin-left: 40px;
  font-size: 13px;
}

.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.image-preview-modal img {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
}
.empty {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  p {
    width: 100%;
    font-size: 18px;
    text-align: center;
  }
}
</style>
